import { useFormikContext } from "formik";
import React from "react";

import { IOtherIncomes } from "../../../../config/interfaces";
import { FormField, NumericInputField } from "../../../fields";

const OIAnyIncomeTaxablePreYear89AForm: React.FC = () => {
  const { values, handleBlur, errors, touched, setFieldValue } = useFormikContext<IOtherIncomes>();

  return (
    <section>
      <div className="section-title-wrap">
        <h5>Income taxable during the previous year on which relief u/s 89A was claimed</h5>
      </div>
      <FormField label="Amount" sm={6}>
        <NumericInputField
          showLeftIcon={true}
          name="IncomeTaxablePreviousYear89A"
          value={values.IncomeTaxablePreviousYear89A}
          onBlur={handleBlur("IncomeTaxablePreviousYear89A")}
          onChange={(value) => setFieldValue("IncomeTaxablePreviousYear89A", value)}
          isInvalid={
            Boolean(errors.IncomeTaxablePreviousYear89A) && touched.IncomeTaxablePreviousYear89A
          }
          errorMsg={errors.IncomeTaxablePreviousYear89A}
        />
      </FormField>
    </section>
  );
};

export default OIAnyIncomeTaxablePreYear89AForm;
